<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="KCPS VNコネクト再実行"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col>
                <span
                  >再実行が必要なVNコネクトが存在します。再実行を行ってください。</span
                ><br />
                <span>再実行が完了するまでVNコネクトの操作はできません。</span>
              </v-col>
            </v-row>
            <app-table
              primary-key="cloudVnConnectAct.wnumber"
              :fields="vnConnects.fields"
              :items="retryList ? [retryList] : []"
              :per-page="-1"
              :tr-class="() => undefined"
            >
              <template #cell(wnumber)="{ item }">
                {{ item.cloudVnConnectAct.wnumber }}<br />
                <template v-if="item.cloudVnConnectSby">{{
                  item.cloudVnConnectSby.wnumber
                }}</template>
                <template v-else>-</template>
              </template>
              <template #cell(vnConnectName)="{ item }">
                {{ item.cloudVnConnectAct.vnConnectName }}<br />
                <template v-if="item.cloudVnConnectSby">{{
                  item.cloudVnConnectSby.vnConnectName
                }}</template>
                <template v-else>-</template>
              </template>
              <template #cell(serviceKey)="{ item }">
                {{ item.cloudVnConnectCommon.serviceKey }}
              </template>
              <template #cell(vpnVnCode)="{ item }">
                <template
                  v-if="item.cloudVnConnectCommon.vpnVnCode.charAt(0) !== 'B'"
                >
                  {{
                    `${item.cloudVnConnectCommon.vpnVnCode}(${item.cloudVnConnectCommon.vnType})`
                  }}
                </template>
                <template v-else>
                  {{ item.cloudVnConnectCommon.vpnVnCode }}
                </template>
              </template>
              <template #cell(bandwidth)="{ item }">
                {{ item.cloudVnConnectCommon.bandwidthType }}({{
                  $filter.bandwidthTo(item.cloudVnConnectCommon.bandwidth)
                }})
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="vnConnectRetry(retryList!.cloudVnConnectAct.wnumber)"
              variant="flat"
              color="primary"
              >再実行</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >キャンセル</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { CloudVnKcpsList } from "@/apis/CloudVnKcpsApi";
import type { AppTableHeader } from "@/components/AppTable.vue";

export default defineComponent({
  name: "MultiCloudKcps3VnConnectionRetry",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    vnConnectList: {
      type: Object as PropType<CloudVnKcpsList>,
      required: true,
    },
    cloudVnKcpsKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      vnConnects: {
        fields: [
          {
            key: "wnumber",
            title: "VNコネクト番号(Act/Sby)",
            width: "150px",
          },
          {
            key: "vnConnectName",
            title: "VNコネクト名(Act/Sby)",
            width: "140px",
          },
          {
            key: "serviceKey",
            title: "KCPSユーザーID",
            width: "160px",
          },
          {
            key: "vpnVnCode",
            title: "接続先VPN/VNコード",
            width: "185px",
          },
          {
            key: "bandwidth",
            title: "品目",
            width: "140px",
          },
        ] as AppTableHeader<CloudVnKcpsList>[],
      },
      isLoaded: false,
    };
  },
  computed: {
    /** 再実行対象のVNコネクト（仕様上1件のみ・V2のみ対象） */
    retryList(): CloudVnKcpsList["cloudVnConnectsList"][0] | undefined {
      return this.vnConnectList.cloudVnConnectsList.find(
        (item) =>
          item.cloudVnConnectCommon.version === "V2" &&
          (item.cloudVnConnectCommon.provStatus === "RETRYABLE" ||
            item.cloudVnConnectCommon.provStatus === "DELETE_RETRYABLE" ||
            item.cloudVnConnectCommon.provStatus === "CREATE_FAILED")
      );
    },
  },
  async mounted() {
    this.isLoaded = true;
  },
  methods: {
    /** VNコネクト再実行 */
    async vnConnectRetry(wnumber: string) {
      await this.$confirm(`VNコネクト再実行を行います。よろしいですか？`);
      await this.$api.cloudVnKcps.cloudVnKcpsRetryV2(
        this.cloudLineSeq,
        wnumber,
        { cloudVnKcpsKeyId: this.cloudVnKcpsKeyId }
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
